import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Function to show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);
    const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
    modal.show();
}

// ✅ MOVE FUNCTION OUTSIDE
function loadAllContacts() {
    $.ajax({
        url: `${API_BASE_URL}/api/contact/all`,
        type: "GET",
        success: function (contacts) {
            let rows = "";
            contacts.reverse().forEach((c, i) => {
                rows += `
                    <tr>
                        <td>${i + 1}</td>
                        <td>${c.userName}</td>
                        <td>${c.userEmail}</td>
                        <td>${c.userPhone}</td>
                        <td>${c.message}</td>
                        <td>
                            <button class="btn btn-danger btn-sm deleteContact" data-id="${c.id}">Delete</button>
                        </td>
                    </tr>
                `;
            });

            $("#allContactsData").html(rows);
        },
        error: function (err) {
            console.error(err);
        }
    });
}

// ✅ EXPOSE TO REACT
window.loadContacts = function () {
    loadAllContacts();
};

$(document).ready(function () {

    // ADD Contact
    $("#contactForm").submit(function (e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("userName", $("#userName").val());
        formData.append("userEmail", $("#userEmail").val());
        formData.append("userPhone", $("#userPhone").val());
        formData.append("message", $("#message").val());

        $.ajax({
            url: `${API_BASE_URL}/api/contact/add`,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function () {
                showSuccessModal("Message Send Successfully!");
                $("#contactForm")[0].reset();

                loadAllContacts();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to Message send!");
            }
        });
    });

    // DELETE Contact
    $(document).on("click", ".deleteContact", function () {
        let id = $(this).data("id");

        if (!window.confirm("Are you sure want to delete this Contact?")) return;

        $.ajax({
            url: `${API_BASE_URL}/api/contact/delete/${id}`,
            type: "DELETE",
            success: function () {
                showSuccessModal("Contact Deleted Successfully!");
                loadAllContacts();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to delete Contact!");
            }
        });
    });

});

// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// window.loadContacts = function () {
//     loadAllContacts();
// };

// $(document).ready(function () {

//     // ADD Contact
//     $("#contactForm").submit(function (e) {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append("userName", $("#userName").val());
//         formData.append("userEmail", $("#userEmail").val());
//         formData.append("userPhone", $("#userPhone").val());
//         formData.append("message", $("#message").val());

//         $.ajax({
//             url: `${API_BASE_URL}/api/contact/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,
//             success: function () {
//                 showSuccessModal("Message Send Successfully!");
//                 $("#contactForm")[0].reset();

//                 loadAllContacts();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to Message send!");
//             }
//         });
//     });

//     // LOAD ALL Contact DATA
//     function loadAllContacts() {
//         $.ajax({
//             url: `${API_BASE_URL}/api/contact/all`,
//             type: "GET",
//             success: function (contacts) {
//                 let rows = "";
//                 contacts.reverse().forEach((c, i) => {
//                     rows += `
//                         <tr>
//                             <td>${i + 1}</td>
//                             <td>${c.userName}</td>
//                             <td>${c.userEmail}</td>
//                             <td>${c.userPhone}</td>
//                             <td>${c.message}</td>
//                             <td>
//                                 <button class="btn btn-danger btn-sm deleteContact" data-id="${c.id}">Delete</button>
//                             </td>
//                         </tr>
//                     `;
//                 });

//                 $("#allContactsData").html(rows);
//             },
//             error: function (err) {
//                 console.error(err);
//             }
//         });
//     }


//     // DELETE Apply
//     $(document).on("click", ".deleteContact", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure want to delete this Contact?")) return;

//         $.ajax({
//             url: `${API_BASE_URL}/api/contact/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Contact Deleted Successfully!");
//                 loadAllContacts();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to delete Contact!");
//             }
//         });
//     });

// });

